import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Element from './Element/Element';
import classes from './SubSectionBar.module.css';
import { parseLocationToPath } from '../../utils';

const SubSectionBar = ({ color, subsections }) => {
  const location = useLocation();
  return (
    <div style={{ backgroundColor: `${color}` }} className={classes.container}>
      {subsections
        .filter(({ name }) => name !== 'Builder Coupon')
        .map(({ id, link, name }) => (
          <Element
            key={id}
            link={link}
            label={name}
            selected={parseLocationToPath(location) === link}
          />
        ))}
    </div>
  );
};

SubSectionBar.propTypes = {
  color: PropTypes.string.isRequired,
  subsections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
export default SubSectionBar;
